import { HttpClient, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject, catchError, shareReplay, throwError } from 'rxjs';
import { AmministrazioneTrasparente, AnagraficaRubrica, AuthUser, CalendarioSpettacolo, Carnet, CarnetInfo, CarnetItem, CastSpettacolo, Configurazione, ConfigurazioneAccreditamenti, ConfigurazioneHome, ConfigurazioneStagione, Contatto, Definizione, DocumentoAccredito, Evento, EventoAccreditamentoSummary, GalleriaSpettacolo, ImpiantoVerifica, Info, InfoItem, Intervento, MakingTecaPost, MakingTecaPostData, MezzoTrasporto, News, Newsletter, Persona, PrezzoSpettacolo, Spettacolo, Stagione, Subappalto, TimelineSpettacolo, Utente, UtenteAccredito, Voucher } from '../shared/interface';
import { environment } from '../../environments/environment';
import { StorageService } from './storage.service';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient, private messageService: MessageService) { }

  Utenti: Utente[] = []
  MakingTecaPost: MakingTecaPost[] = []
  FilesAmministrazioneTrasparente: AmministrazioneTrasparente[] = []
  News: News[] = [];
  Contatti: Contatto[] = [];
  Definizioni: Definizione[] = [];
  Spettacoli: Spettacolo[] = [];
  Newsletters: Newsletter[] = [];
  Configurazioni: Configurazione[] = [];
  Vouchers: Voucher[] = [];
  Carnets: Carnet[] = [];
  Infos: Info[] = [];

  /** ponytail: session cache per GET pubblici ripetuti tra pagine; bustCache() su write backoffice */
  private httpCache = new Map<string, Observable<unknown>>();

  private cachedGet<T>(key: string, url: string): Observable<T> {
    if (!this.httpCache.has(key)) {
      this.httpCache.set(key, this.http.get<T>(url).pipe(shareReplay(1)));
    }
    return this.httpCache.get(key) as Observable<T>;
  }

  private bustCache(...keys: string[]) {
    keys.forEach((k) => this.httpCache.delete(k));
  }
  
  Eventi: Evento[] = [];
  PersonaleEvento: Persona[] = [];
  SubappaltiEvento: Subappalto[] = [];
  MezziTrasportoEvento: MezzoTrasporto[] = [];
  DocumentiEvento: DocumentoAccredito[] = [];
  UtentiAccrediti: UtenteAccredito[] = [];
  UtentiAccreditiSpettacolo: UtenteAccredito[] = [];

  utentiChanged = new Subject<Utente[]>();
  makingTecaPostChanged = new Subject<MakingTecaPost[]>();
  filesAmministrazioneTrasparenteChanged = new Subject<AmministrazioneTrasparente[]>();
  newsChanged = new Subject<News[]>();
  contattiChanged = new Subject<Contatto[]>();
  definizioniChanged = new Subject<Definizione[]>();
  spettacoliChanged = new Subject<Spettacolo[]>();
  newslettersChanged = new Subject<Newsletter[]>();
  configurazioniChanged = new Subject<Configurazione[]>();
  vouchersChanged = new Subject<Voucher[]>();
  carnetsChanged = new Subject<Carnet[]>();
  infosChanged = new Subject<Info[]>();

  eventiChanged = new Subject<Evento[]>();
  personaleEventoChanged = new Subject<Persona[]>();
  subappaltiEventoChanged = new Subject<Subappalto[]>();
  mezziTrasportoEventoChanged = new Subject<MezzoTrasporto[]>();
  documentiEventoChanged = new Subject<DocumentoAccredito[]>();
  utentiAccreditiChanged = new Subject<UtenteAccredito[]>();
  utentiAccreditiSpettacoloChanged = new Subject<UtenteAccredito[]>();


  setUtenti() {
    this.http.get<Utente[]>(`${environment.apiURL}v1.0/utenti`).subscribe(utenti => {
      this.Utenti = utenti;
      this.utentiChanged.next(this.Utenti.slice());
    })
  }
  setMakingTecaPosts() {
    this.bustCache('making_teca_posts');
    this.http.get<MakingTecaPost[]>(`${environment.apiURL}making_teca_posts`).subscribe(posts => {
      this.MakingTecaPost = posts;
      this.makingTecaPostChanged.next(this.MakingTecaPost.slice());
    })
  }
  setFilesAmministrazioneTrasparente() {
    this.bustCache('files_amministrazione_trasparente');
    this.http.get<AmministrazioneTrasparente[]>(`${environment.apiURL}files_amministrazione_trasparente`).subscribe(files => {
      this.FilesAmministrazioneTrasparente = files;
      this.filesAmministrazioneTrasparenteChanged.next(this.FilesAmministrazioneTrasparente.slice());
    })
  }
  setNotizie() {
    this.bustCache('notizie');
    this.http.get<News[]>(`${environment.apiURL}notizie`).subscribe(news => {
      this.News = news;
      this.newsChanged.next(this.News.slice());
    })
  }
  setContatti() {
    this.bustCache('contatti');
    this.http.get<Contatto[]>(`${environment.apiURL}contatti`).subscribe(contatti => {
      this.Contatti = contatti;
      this.contattiChanged.next(this.Contatti.slice());
    })
  }
  setDefinizioni() {
    this.bustCache('definizioni');
    this.http.get<Definizione[]>(`${environment.apiURL}definizioni`).subscribe(definizioni => {
      this.Definizioni = definizioni;
      this.definizioniChanged.next(this.Definizioni.slice());
    })
  }
  setSpettacoli() {
    this.bustCache('spettacoli', 'stagione');
    this.http.get<Spettacolo[]>(`${environment.apiURL}v1.0/spettacoli`).subscribe(spettacoli => {
      this.Spettacoli = spettacoli;
      this.spettacoliChanged.next(this.Spettacoli.slice());
    })
  }
  setNewsletters() {
    this.http.get<Newsletter[]>(`${environment.apiURL}v1.0/newsletters`).subscribe(newsletters => {
      this.Newsletters = newsletters;
      this.newslettersChanged.next(this.Newsletters.slice());
    })
  }
  setConfigurazioni() {
    this.http.get<Configurazione[]>(`${environment.apiURL}v1.0/configurazioni`).subscribe(configurazioni => {
      this.Configurazioni = configurazioni;
      this.configurazioniChanged.next(this.Configurazioni.slice());
    })
  }
  setVouchers() {
    this.http.get<Voucher[]>(`${environment.apiURL}v1.0/vouchers`).subscribe(vouchers => {
      this.Vouchers = vouchers;
      this.vouchersChanged.next(this.Vouchers.slice());
    })
  }
  setCarnets() {
    this.bustCache('carnets');
    this.http.get<Carnet[]>(`${environment.apiURL}carnets`).subscribe(carnets => {
      this.Carnets = carnets;
      this.carnetsChanged.next(this.Carnets.slice());
    })
  }
  setInfos() {
    this.bustCache('infos');
    this.http.get<Info[]>(`${environment.apiURL}infos`).subscribe(infos => {
      this.Infos = infos;
      this.infosChanged.next(this.Infos.slice());
    })
  }
  setEventi() {
    this.http.get<Evento[]>(`${environment.apiURL}v1.0/eventi`).subscribe((eventi) => {
      this.Eventi = eventi;
      this.eventiChanged.next(this.Eventi.slice());
    });
  }
  setPersonaleEvento(id_evento: number) {
    this.http.get<Persona[]>(`${environment.apiURL}v1.0/personale/${id_evento}/evento`).subscribe((personale) => {
      this.PersonaleEvento = personale;
      this.personaleEventoChanged.next(this.PersonaleEvento.slice());
    });
  }
  setSubappaltiEvento(id_evento: number) {
    this.http.get<Subappalto[]>(`${environment.apiURL}v1.0/subappalti/${id_evento}/evento`).subscribe((subappalti) => {
      this.SubappaltiEvento = subappalti;
      this.subappaltiEventoChanged.next(this.SubappaltiEvento.slice());
    });
  }
  setMezziTrasportoEvento(id_evento: number) {
    this.http.get<MezzoTrasporto[]>(`${environment.apiURL}v1.0/mezzi_trasporto/${id_evento}/evento`).subscribe((mezzi_trasporto) => {
      this.MezziTrasportoEvento = mezzi_trasporto;
      this.mezziTrasportoEventoChanged.next(this.MezziTrasportoEvento.slice());
    });
  }
  setDocumentiEvento(id_evento: number) {
    this.http.get<DocumentoAccredito[]>(`${environment.apiURL}v1.0/documenti/${id_evento}/evento`).subscribe((documenti) => {
      this.DocumentiEvento = documenti;
      this.documentiEventoChanged.next(this.DocumentiEvento.slice());
    });
  }
  setUtentiAccrediti() {
    this.http.get<UtenteAccredito[]>(`${environment.apiURL}v1.0/utenti_accrediti`).subscribe((utenti) => {
      this.UtentiAccrediti = utenti;
      this.utentiAccreditiChanged.next(this.UtentiAccrediti.slice());
    });
  }  
  setUtentiAccreditoSpettacolo(id_spettacolo: number) {
    this.http.get<UtenteAccredito[]>(`${environment.apiURL}v1.0/utenti_accrediti/${id_spettacolo}`).subscribe((utenti) => {
      this.UtentiAccreditiSpettacolo = utenti;
      this.utentiAccreditiSpettacoloChanged.next(this.UtentiAccreditiSpettacolo.slice());
    });
  }  

  isAuthorized() {
    return this.http.get<boolean | { result: boolean }>(environment.authURL);
  }
  login(user: string, pass: string) {
    const body = { username: user, password: pass };
    return this.http.post<any>(environment.loginURL, body);
  }

  getMakingTecaPosts() {
    return this.cachedGet<MakingTecaPost[]>('making_teca_posts', `${environment.apiURL}making_teca_posts`);
  }
  getDefinizioni() {
    return this.cachedGet<Definizione[]>('definizioni', `${environment.apiURL}definizioni`);
  }
  getNotizie() {
    return this.cachedGet<News[]>('notizie', `${environment.apiURL}notizie`);
  }
  getFilesAmministrazioneTrasparente() {
    return this.cachedGet<AmministrazioneTrasparente[]>('files_amministrazione_trasparente', `${environment.apiURL}files_amministrazione_trasparente`);
  }
  getUtenti() {
    return this.http.get<Utente[]>(`${environment.apiURL}v1.0/utenti`)
  }
  getContatti() {
    return this.cachedGet<Contatto[]>('contatti', `${environment.apiURL}contatti`);
  }
  getSpettacoli() {
    return this.cachedGet<Spettacolo[]>('spettacoli', `${environment.apiURL}spettacoli`);
  }
  getNewsletters() {
    return this.http.get<Newsletter[]>(`${environment.apiURL}v1.0/newsletters`)
  }
  getConfigurazioni() {
    return this.http.get<Configurazione[]>(`${environment.apiURL}v1.0/configurazioni`)
  }
  getConfigurazioneStagione() {
    return this.cachedGet<ConfigurazioneStagione>('configurazione_stagione', `${environment.apiURL}configurazione_stagione/`);
  }
  getConfigurazioneHome() {
    return this.cachedGet<ConfigurazioneHome>('configurazione_home', `${environment.apiURL}configurazione_home/`);
  }
  getEventi() {
    return this.http.get<Evento[]>(`${environment.apiURL}v1.0/eventi`)
  }
  getPersonale() {
    return this.http.get<Persona[]>(`${environment.apiURL}v1.0/personale`)
  }
  getPersonaleEvento(id_evento: number) {
    return this.http.get<Persona[]>(`${environment.apiURL}v1.0/personale/${id_evento}/evento`)
  }
  getSubappalti() {
    return this.http.get<Subappalto[]>(`${environment.apiURL}v1.0/subappalti`)
  }
  getSubappaltiEvento(id_evento: number) {
    return this.http.get<Subappalto[]>(`${environment.apiURL}v1.0/subappalti/${id_evento}/evento`)
  }
  getMezziTrasporto() {
    return this.http.get<MezzoTrasporto[]>(`${environment.apiURL}v1.0/mezzi_trasporto`)
  }
  getMezziTrasportoEvento(id_evento: number) {
    return this.http.get<MezzoTrasporto[]>(`${environment.apiURL}v1.0/mezzi_trasporto/${id_evento}/evento`)
  }
  getUtentiAccrediti() {
    return this.http.get<UtenteAccredito[]>(`${environment.apiURL}v1.0/utenti_accrediti`)
  }
  getConfigurazioneAccreditamenti() {
    return this.http.get<ConfigurazioneAccreditamenti>(`${environment.apiURL}v1.0/configurazione_accreditamenti/`)
  }

  getEventiAccreditamentiSummary(dal?: string, al?: string) {
    const params: string[] = [];
    if (dal) params.push(`dal=${encodeURIComponent(dal)}`);
    if (al) params.push(`al=${encodeURIComponent(al)}`);
    const qs = params.length ? `?${params.join('&')}` : '';
    return this.http.get<EventoAccreditamentoSummary[]>(`${environment.apiURL}v1.0/eventi_accreditamenti_summary${qs}`);
  }

  getEventoAccreditamentoSummary(id: number) {
    return this.http.get<EventoAccreditamentoSummary>(`${environment.apiURL}v1.0/evento_accreditamento_summary/${id}`);
  }

  getInterventi(dal?: string, al?: string, tipo?: string) {
    const params: string[] = [];
    if (dal) params.push(`dal=${encodeURIComponent(dal)}`);
    if (al) params.push(`al=${encodeURIComponent(al)}`);
    if (tipo) params.push(`tipo=${encodeURIComponent(tipo)}`);
    const qs = params.length ? `?${params.join('&')}` : '';
    return this.http.get<Intervento[]>(`${environment.apiURL}v1.0/interventi${qs}`);
  }

  getInterventiProssimi() {
    return this.http.get<Intervento[]>(`${environment.apiURL}v1.0/interventi_prossimi`);
  }

  getIntervento(id: number) {
    return this.http.get<Intervento>(`${environment.apiURL}v1.0/intervento/${id}`);
  }

  addIntervento(form: FormData) {
    return this.http.post<{ code: number; id: number }>(`${environment.apiURL}v1.0/intervento`, form);
  }

  updateIntervento(form: FormData, id: number) {
    return this.http.put(`${environment.apiURL}v1.0/intervento/${id}`, form);
  }

  deleteIntervento(id: number) {
    return this.http.delete(`${environment.apiURL}v1.0/intervento/${id}`);
  }

  getRubrica(tipo?: string) {
    const qs = tipo ? `?tipo=${encodeURIComponent(tipo)}` : '';
    return this.http.get<AnagraficaRubrica[]>(`${environment.apiURL}v1.0/rubrica${qs}`);
  }

  getAnagraficaRubrica(id: number) {
    return this.http.get<AnagraficaRubrica>(`${environment.apiURL}v1.0/rubrica/${id}`);
  }

  addRubrica(form: FormData) {
    return this.http.post<{ code: number; id: number }>(`${environment.apiURL}v1.0/rubrica`, form);
  }

  updateRubrica(form: FormData, id: number) {
    return this.http.put(`${environment.apiURL}v1.0/rubrica/${id}`, form);
  }

  deleteRubrica(id: number) {
    return this.http.delete(`${environment.apiURL}v1.0/rubrica/${id}`);
  }

  importRubricaDaEventi() {
    return this.http.post<{ code: number; inserted: number; skipped: number }>(`${environment.apiURL}v1.0/rubrica/import_da_eventi`, {});
  }

  creaEventoDaRubrica(id: number, body: { evento: string; dal: string; al: string }) {
    return this.http.post<{ code: number; id: number }>(`${environment.apiURL}v1.0/rubrica/${id}/crea_evento`, body);
  }

  getImpianti() {
    return this.http.get<ImpiantoVerifica[]>(`${environment.apiURL}v1.0/impianti`);
  }

  getImpianto(id: number) {
    return this.http.get<ImpiantoVerifica>(`${environment.apiURL}v1.0/impianto/${id}`);
  }

  addImpianto(form: FormData) {
    return this.http.post<{ code: number; id: number }>(`${environment.apiURL}v1.0/impianto`, form);
  }

  updateImpianto(form: FormData, id: number) {
    return this.http.put(`${environment.apiURL}v1.0/impianto/${id}`, form);
  }

  deleteImpianto(id: number) {
    return this.http.delete(`${environment.apiURL}v1.0/impianto/${id}`);
  }

  getMakingTecaPost(id: number) {
    return this.http.get<MakingTecaPost>(`${environment.apiURL}making_teca_post/${id}`)
  }
  getDefinizione(id: number) {
    return this.http.get<Definizione>(`${environment.apiURL}v1.0/definizione/${id}`)
  }
  getNotizia(id: number) {
    return this.http.get<News>(`${environment.apiURL}v1.0/notizia/${id}`)
  }
  getUtente(id: number) {
    return this.http.get<Utente>(`${environment.apiURL}v1.0/utente/${id}`)
  }
  getFileAmministrazioneTrasparente(id: number) {
    return this.http.get<AmministrazioneTrasparente>(`${environment.apiURL}v1.0/file_amministrazione_trasparente/${id}`)
  }
  getContatto(id: number) {
    return this.http.get<Contatto>(`${environment.apiURL}v1.0/contatto/${id}`)
  }
  getSpettacolo(id: number) {
    return this.http.get<Spettacolo>(`${environment.apiURL}v1.0/spettacolo/${id}`)
  }
  getSpettacoloByName(spettacolo: string, dal: string, al: string) {
    return this.http.get<Spettacolo>(`${environment.apiURL}spettacolo`, { params: { spettacolo: spettacolo, dal: dal, al: al } })
  }
  getNewsletter(id: number) {
    return this.http.get<Newsletter>(`${environment.apiURL}v1.0/newsletter/${id}`)
  }
  getConfigurazione(id: number) {
    return this.http.get<Configurazione>(`${environment.apiURL}v1.0/configurazione/${id}`)
  }
  getVoucher(id: number) {
    return this.http.get<Voucher>(`${environment.apiURL}v1.0/voucher/${id}`)
  }
  getCarnet(id: number) {
    return this.http.get<Carnet>(`${environment.apiURL}v1.0/carnet/${id}`)
  }
  getInfo(id: number) {
    return this.http.get<Info>(`${environment.apiURL}v1.0/info/${id}`)
  }
  getEvento(id: number) {
    return this.http.get<Evento>(`${environment.apiURL}v1.0/evento/${id}`)
  }
  getEventoSpettacolo(id_spettacolo: number) {
    return this.http.get<Evento>(`${environment.apiURL}v1.0/evento_spettacolo/${id_spettacolo}`)
  }
  getPersona(id: number) {
    return this.http.get<Persona>(`${environment.apiURL}v1.0/persona/${id}`)
  }
  getSubappalto(id: number) {
    return this.http.get<Subappalto>(`${environment.apiURL}v1.0/subappalto/${id}`)
  }
  getMezzoTrasporto(id: number) {
    return this.http.get<MezzoTrasporto>(`${environment.apiURL}v1.0/mezzo_trasporto/${id}`)
  }
  getBadge(id: number) {
    return this.http.get(`${environment.apiURL}v1.0/badge/${id}`, { responseType: 'blob' })
  }
  getBadgePersonale(id_evento: number) {
    return this.http.get(`${environment.apiURL}v1.0/badge_personale/${id_evento}`, { responseType: 'blob' })
  }
  getZipDocumenti(documenti: DocumentoAccredito[]) {
    return this.http.post(`${environment.apiURL}v1.0/zip_documenti`, {documenti: documenti}, { responseType: 'blob' })
  }
  getUtenteAccredito(id: number) {
    return this.http.get<UtenteAccredito>(`${environment.apiURL}v1.0/utente_accredito/${id}`)
  }


  getMakingTecaPostData(id_post: number) {
    return this.http.get<MakingTecaPostData[]>(`${environment.apiURL}making_teca_post_data/${id_post}`)
  }
  getNotiziaUrl(url: string) {
    return this.http.get<News>(`${environment.apiURL}notizia_url/${url}`)
  }
  getCalendarioSpettacolo(id_spettacolo: number) {
    return this.http.get<CalendarioSpettacolo[]>(`${environment.apiURL}calendario_spettacolo/${id_spettacolo}`)
  }
  getPrezziSpettacolo(id_spettacolo: number) {
    return this.http.get<PrezzoSpettacolo[]>(`${environment.apiURL}prezzi_spettacolo/${id_spettacolo}`)
  }
  getCastSpettacolo(id_spettacolo: number) {
    return this.http.get<CastSpettacolo[]>(`${environment.apiURL}cast_spettacolo/${id_spettacolo}`)
  }
  getGalleriaSpettacolo(id_spettacolo: number) {
    return this.http.get<GalleriaSpettacolo[]>(`${environment.apiURL}gallery_spettacolo/${id_spettacolo}`)
  }
  getTimelineSpettacolo(id_spettacolo: number) {
    return this.http.get<TimelineSpettacolo[]>(`${environment.apiURL}timeline_spettacolo/${id_spettacolo}`)
  }
  getStagione() {
    return this.cachedGet<Stagione>('stagione', `${environment.apiURL}stagione`);
  }
  getCarnets() {
    return this.cachedGet<Carnet[]>('carnets', `${environment.apiURL}carnets`);
  }
  getInfos() {
    return this.cachedGet<Info[]>('infos', `${environment.apiURL}infos`);
  }
  getCarnetInfo() {
    return this.cachedGet<CarnetInfo>('carnet_info', `${environment.apiURL}carnet_info`);
  }
 


  addUtente(utente: { username: string, email: string, password: string, tipo: string }) {
    return this.http.post(`${environment.apiURL}v1.0/utente`, utente)
  }
  addMakingTecaPost(post: FormData) {
    this.bustCache('making_teca_posts');
    return this.http.post<{ id: number, code: number }>(`${environment.apiURL}v1.0/making_teca_post`, post)
  }
  addMakingTecaPostData(post_data: FormData) {
    return this.http.post(`${environment.apiURL}v1.0/making_teca_post_data`, post_data)
  }
  addFileAmministrazioneTrasparente(file: FormData) {
    this.bustCache('files_amministrazione_trasparente');
    return this.http.post(`${environment.apiURL}v1.0/file_amministrazione_trasparente`, file)
  }
  addNotizia(news: { titolo: string, descrizione: string, data: string | null, evidenzia: boolean, link: boolean, link_url: string }) {
    this.bustCache('notizie');
    return this.http.post(`${environment.apiURL}v1.0/notizia`, news)
  }
  addContatto(contatto: { titolo: string, descrizione: string }) {
    this.bustCache('contatti');
    return this.http.post(`${environment.apiURL}v1.0/contatto`, contatto)
  }
  addDefinizione(definizione: { alfabeto: string, titolo: string, definizione: string }) {
    this.bustCache('definizioni');
    return this.http.post(`${environment.apiURL}v1.0/definizione`, definizione)
  }
  addNewsletter(newsletter: { email: string }) {
    return this.http.post(`${environment.apiURL}newsletter`, newsletter)
  }
  addConfigurazione(configurazione: { descrizione: string, value: string }) {
    return this.http.post(`${environment.apiURL}v1.0/configurazione`, configurazione)
  }
  addVoucher(voucher: { cliente: string, email: string, telefono: string, credito: number, codice: string, data_scadenza: string | null }) {
    return this.http.post(`${environment.apiURL}v1.0/voucher`, voucher)
  }
  addCarnet(carnet: { items: CarnetItem[] }) {
    this.bustCache('carnets');
    return this.http.post(`${environment.apiURL}v1.0/carnet`, carnet)
  }
  addCarnetInfo(info: { titolo: string, descrizione: string, link: string, attivo: boolean }) {
    this.bustCache('carnet_info');
    return this.http.post(`${environment.apiURL}v1.0/carnet_info`, info)
  }
  addInfo(info: { lughezza: string, items: InfoItem[] }) {
    this.bustCache('infos');
    return this.http.post(`${environment.apiURL}v1.0/info`, info)
  }
  addConfigurazioneStagione(conf: FormData) {
    this.bustCache('configurazione_stagione', 'stagione');
    return this.http.post(`${environment.apiURL}v1.0/configurazione_stagione/`, conf)
  }
  addConfigurazioneHome(conf: FormData) {
    this.bustCache('configurazione_home');
    return this.http.post(`${environment.apiURL}v1.0/configurazione_home/`, conf)
  }
  addCalendarioSpettacolo(calendario_spettacolo: { calendario: CalendarioSpettacolo[] }, id_spettacolo: number) {
    this.bustCache('spettacoli', 'stagione');
    return this.http.post(`${environment.apiURL}v1.0/calendario_spettacolo/${id_spettacolo}`, calendario_spettacolo)
  }
  addPrezziSpettacolo(prezzi_spettacolo: { prezzi: PrezzoSpettacolo[] }, id_spettacolo: number) {
    return this.http.post(`${environment.apiURL}v1.0/prezzo_spettacolo/${id_spettacolo}`, prezzi_spettacolo)
  }
  addCastSpettacolo(cast_spettacolo: { casts: CastSpettacolo[] }, id_spettacolo: number) {
    return this.http.post(`${environment.apiURL}v1.0/cast_spettacolo/${id_spettacolo}`, cast_spettacolo)
  }
  addGalleriaSpettacolo(galleria: FormData, id_spettacolo: number) {
    return this.http.post(`${environment.apiURL}v1.0/gallery_spettacolo/${id_spettacolo}`, galleria)
  }
  addTimelineSpettacolo(timeline: FormData, id_spettacolo: number) {
    return this.http.post(`${environment.apiURL}v1.0/timeline_spettacolo/${id_spettacolo}`, timeline)
  }
  addSpettacolo(spettacolo: { spettacolo: string, compagnia: string, descrizione: string, dal: string | null, al: string | null, prenotabile_dal: string | null, prenotabile_dal_orario: string | null, online: boolean, evidenzia: boolean, gratuito: boolean, in_vendita_dal: boolean, in_vendita_dal_data: string | null, soon_in_vendita: boolean, sold_out: boolean, annullato: boolean, webshop: boolean, custom: boolean, link_webshop: string, link_custom: string, descrizione_prezzi: string, img_box: string, img_home: string, img_cover: string }) {
    this.bustCache('spettacoli', 'stagione');
    return this.http.post<{ code: number; id: number }>(`${environment.apiURL}v1.0/spettacolo/`, spettacolo)
  }
  addPersonale(personale: FormData) {
    return this.http.post(`${environment.apiURL}v1.0/personale/`, personale)
  }  
  addSubappalto(subappalto: FormData) {
    return this.http.post(`${environment.apiURL}v1.0/subappalto/`, subappalto)
  }  
  addMezzoTrasporto(mezzo: { id_evento: string, tipologia: string, targa: string, ditta: string }) {
    return this.http.post(`${environment.apiURL}v1.0/mezzo_trasporto/`, mezzo)
  }  
  addUtenteAccredito(utente: { username: string, email: string, password: string, id_spettacolo: number }) {
    return this.http.post(`${environment.apiURL}v1.0/utente_accredito`, utente)
  }
  addConfigurazioneAccreditamenti(conf: FormData) {
    return this.http.post(`${environment.apiURL}v1.0/configurazione_accreditamenti/`, conf)
  }


  updateUtente(utente: { username: string, email: string, tipo: string }, id: number) {
    return this.http.put(`${environment.apiURL}v1.0/utente/${id}`, utente)
  }
  updatePasswordUtente(utente: { password: string }, id: number) {
    return this.http.put(`${environment.apiURL}v1.0/password_utente/${id}`, utente)
  }
  updateMakingTecaPost(post: FormData, id: number) {
    this.bustCache('making_teca_posts');
    return this.http.put<{ id: number, code: number }>(`${environment.apiURL}v1.0/making_teca_post/${id}`, post)
  }
  updateMakingTecaPostData(post_data: FormData, id: number) {
    return this.http.put(`${environment.apiURL}v1.0/making_teca_post_data/${id}`, post_data)
  }
  updateFileAmministrazioneTrasparente(file: FormData, id: number) {
    this.bustCache('files_amministrazione_trasparente');
    return this.http.put(`${environment.apiURL}v1.0/file_amministrazione_trasparente/${id}`, file)
  }
  updateNotizia(news: { titolo: string, data: string | null, descrizione: string, evidenzia: boolean, link: boolean, link_url: string }, id: number) {
    this.bustCache('notizie');
    return this.http.put(`${environment.apiURL}v1.0/notizia/${id}`, news)
  }
  updateContatto(contatto: { titolo: string, descrizione: string }, id: number) {
    this.bustCache('contatti');
    return this.http.put(`${environment.apiURL}v1.0/contatto/${id}`, contatto)
  }
  updateDefinizione(definizione: { alfabeto: string, titolo: string, definizione: string }, id: number) {
    this.bustCache('definizioni');
    return this.http.put(`${environment.apiURL}v1.0/definizione/${id}`, definizione)
  }
  updateNewsletter(newsletter: { email: string }, id: number) {
    return this.http.put(`${environment.apiURL}v1.0/newsletter/${id}`, newsletter)
  }
  updateConfigurazione(configurazione: { descrizione: string, value: string }, id: number) {
    return this.http.put(`${environment.apiURL}v1.0/configurazione/${id}`, configurazione)
  }
  updateConfigurazioneStagione(file: FormData) {
    this.bustCache('configurazione_stagione', 'stagione');
    return this.http.put(`${environment.apiURL}v1.0/configurazione_stagione`, file)
  }
  updateConfigurazioneHome(file: FormData) {
    this.bustCache('configurazione_home');
    return this.http.put(`${environment.apiURL}v1.0/configurazione_home`, file)
  }
  updateVoucher(voucher: { cliente: string, email: string, telefono: string, credito: number, codice: string, data_scadenza: string | null }, id: number) {
    return this.http.put(`${environment.apiURL}v1.0/voucher/${id}`, voucher)
  }
  updateCarnet(carnet: { items: CarnetItem[] }, id: number) {
    this.bustCache('carnets');
    return this.http.put(`${environment.apiURL}v1.0/carnet/${id}`, carnet)
  }
  updateCarnets(carnets: { carnets: Carnet[] }) {
    this.bustCache('carnets');
    return this.http.put(`${environment.apiURL}v1.0/carnets/`, carnets)
  }
  updateCarnetInfo(info: {titolo: string, descrizione: string, link: string, attivo: boolean}) {
    this.bustCache('carnet_info');
    return this.http.put(`${environment.apiURL}v1.0/carnet_info`, info)
  }
  updateInfo(info: { items: InfoItem[] }, id: number) {
    this.bustCache('infos');
    return this.http.put(`${environment.apiURL}v1.0/info/${id}`, info)
  }
  updateInfos(infos: { infos: Info[] }) {
    this.bustCache('infos');
    return this.http.put(`${environment.apiURL}v1.0/infos/`, infos)
  }
  updateCalendarioSpettacolo(calendario_spettacolo: { calendario: CalendarioSpettacolo[] }, id_spettacolo: number) {
    this.bustCache('spettacoli', 'stagione');
    return this.http.put(`${environment.apiURL}v1.0/calendario_spettacolo/${id_spettacolo}`, calendario_spettacolo)
  }
  updatePrezziSpettacolo(prezzi_spettacolo: { prezzi: PrezzoSpettacolo[] }, id_spettacolo: number) {
    return this.http.put(`${environment.apiURL}v1.0/prezzo_spettacolo/${id_spettacolo}`, prezzi_spettacolo)
  }
  updateCastSpettacolo(cast_spettacolo: { casts: CastSpettacolo[] }, id_spettacolo: number) {
    return this.http.put(`${environment.apiURL}v1.0/cast_spettacolo/${id_spettacolo}`, cast_spettacolo)
  }
  updateGalleriaSpettacolo(galleria_spettacolo: { galleria: GalleriaSpettacolo[] }, id_spettacolo: number) {
    return this.http.put(`${environment.apiURL}v1.0/gallery_spettacolo/${id_spettacolo}`, galleria_spettacolo)
  }
  updateTimelineSpettacolo(timeline_spettacolo: { timeline: TimelineSpettacolo[] }, id_spettacolo: number) {
    return this.http.put(`${environment.apiURL}v1.0/timeline_spettacolo/${id_spettacolo}`, timeline_spettacolo)
  }
  updateSpettacolo(spettacolo: { spettacolo: string, compagnia: string, descrizione: string, dal: string | null, al: string | null, prenotabile_dal: string | null, prenotabile_dal_orario: string | null, online: boolean, evidenzia: boolean, gratuito: boolean, in_vendita_dal: boolean, in_vendita_dal_data: string | null, soon_in_vendita: boolean, sold_out: boolean, annullato: boolean, webshop: boolean, custom: boolean, link_webshop: string, link_custom: string, descrizione_prezzi: string }, id: number) {
    this.bustCache('spettacoli', 'stagione');
    return this.http.put(`${environment.apiURL}v1.0/spettacolo/${id}`, spettacolo)
  }
  updateEvento(evento: FormData, id: number) {
    return this.http.put(`${environment.apiURL}v1.0/evento/${id}`, evento)
  }
  updatePersonale(personale: FormData, id: number) {
    return this.http.put(`${environment.apiURL}v1.0/personale/${id}`, personale)
  }
  updateSubappalto(subappalto: FormData, id: number) {
    return this.http.put(`${environment.apiURL}v1.0/subappalto/${id}`, subappalto)
  }
  updateMezzoTrasporto(mezzo: { id_evento: string, tipologia: string, targa: string, ditta: string }, id: number) {
    return this.http.put(`${environment.apiURL}v1.0/mezzo_trasporto/${id}`, mezzo)
  }  
  updateUtenteAccredito(utente: { username: string, email: string, spettacolo: number }, id: number) {
    return this.http.put(`${environment.apiURL}v1.0/utente_accredito/${id}`, utente)
  }
  updatePasswordUtenteAccredito(utente: { password: string }, id: number) {
    return this.http.put(`${environment.apiURL}v1.0/password_utente_accredito/${id}`, utente)
  }  
  updateConfigurazioneAccreditamenti(file: FormData) {
    return this.http.put(`${environment.apiURL}v1.0/configurazione_accreditamenti`, file)
  }
  updateStatoDocumento(stato: string, id: number) {
    return this.http.put(`${environment.apiURL}v1.0/documento_accredito/${id}`, { stato: stato })
  }
  updateScadenzaDocumento(data_scadenza: string | null, id: number) {
    return this.http.put(`${environment.apiURL}v1.0/documento_accredito/${id}`, { data_scadenza })
  }
  updateVisuraScadenza(id_evento: number, data_scadenza: string | null) {
    return this.http.put(`${environment.apiURL}v1.0/evento_visura_scadenza/${id_evento}`, { data_scadenza })
  }

  deleteUtente(id: number) {
    return this.http.delete(`${environment.apiURL}v1.0/utente/${id}`)
  }
  deleteMakingTecaPost(id: number) {
    this.bustCache('making_teca_posts');
    return this.http.delete(`${environment.apiURL}v1.0/making_teca_post/${id}`)
  }
  deleteFileAmministrazioneTrasparente(id: number) {
    this.bustCache('files_amministrazione_trasparente');
    return this.http.delete(`${environment.apiURL}v1.0/file_amministrazione_trasparente/${id}`)
  }
  deleteNotizia(id: number) {
    this.bustCache('notizie');
    return this.http.delete(`${environment.apiURL}v1.0/notizia/${id}`)
  }
  deleteContatto(id: number) {
    this.bustCache('contatti');
    return this.http.delete(`${environment.apiURL}v1.0/contatto/${id}`)
  }
  deleteDefinizione(id: number) {
    this.bustCache('definizioni');
    return this.http.delete(`${environment.apiURL}v1.0/definizione/${id}`)
  }
  deleteNewsletter(id: number) {
    return this.http.delete(`${environment.apiURL}v1.0/newsletter/${id}`)
  }
  deleteConfigurazione(id: number) {
    return this.http.delete(`${environment.apiURL}v1.0/configurazione/${id}`)
  }
  deleteVoucher(id: number) {
    return this.http.delete(`${environment.apiURL}v1.0/voucher/${id}`)
  }
  deleteCarnet(id: number) {
    this.bustCache('carnets');
    return this.http.delete(`${environment.apiURL}v1.0/carnet/${id}`)
  }
  deleteInfo(id: number) {
    this.bustCache('infos');
    return this.http.delete(`${environment.apiURL}v1.0/info/${id}`)
  }
  deleteCalendarioSpettacolo(id: number) {
    this.bustCache('spettacoli', 'stagione');
    return this.http.delete(`${environment.apiURL}v1.0/calendario_spettacolo/${id}`)
  }
  deletePrezzoSpettacolo(id: number) {
    return this.http.delete(`${environment.apiURL}v1.0/prezzo_spettacolo/${id}`)
  }
  deleteCastSpettacolo(id: number) {
    return this.http.delete(`${environment.apiURL}v1.0/cast_spettacolo/${id}`)
  }
  deleteGalleriaSpettacolo(id: number) {
    return this.http.delete(`${environment.apiURL}v1.0/gallery_spettacolo/${id}`)
  }
  deleteTimelineSpettacolo(id: number) {
    return this.http.delete(`${environment.apiURL}v1.0/timeline_spettacolo/${id}`)
  }
  deleteSpettacolo(id: number) {
    this.bustCache('spettacoli', 'stagione');
    return this.http.delete(`${environment.apiURL}v1.0/spettacolo/${id}`)
  }
  deleteEvento(id: number) {
    return this.http.delete(`${environment.apiURL}v1.0/evento/${id}`)
  }
  deletePersonale(id: number) {
    return this.http.delete(`${environment.apiURL}v1.0/personale/${id}`)
  }
  deleteSubappalto(id: number) {
    return this.http.delete(`${environment.apiURL}v1.0/subappalto/${id}`)
  }
  deleteMezzoTrasporto(id: number) {
    return this.http.delete(`${environment.apiURL}v1.0/mezzo_trasporto/${id}`)
  }
  deleteUtenteAccreditoSpettacolo(id: number, spettacolo: number) {
    return this.http.delete(`${environment.apiURL}v1.0/utente_accredito/${id}/spettacolo/${spettacolo}`)
  }
  deleteUtenteAccredito(id: number) {
    return this.http.delete(`${environment.apiURL}v1.0/utente_accredito/${id}`)
  }
  deleteDocumentoAccredito(id: number) {
    return this.http.delete(`${environment.apiURL}v1.0/documento_accredito/${id}`)
  }
  deleteDocumentoCompagnia(id_evento: number, tipo: string) {
    return this.http.delete(`${environment.apiURL}v1.0/documento_compagnia/${id_evento}`, {params: {tipo: tipo}})
  }
  deleteDocumentoSubappalto(id_subappalto: number, tipo: string) {
    return this.http.delete(`${environment.apiURL}v1.0/documento_subappalto/${id_subappalto}`, {params: {tipo: tipo}})
  }
  deleteConfigurazioneAccreditamenti(tipo: string) {
    return this.http.delete(`${environment.apiURL}v1.0/configurazione_accreditamenti`, {params: {tipo: tipo}})
  }

  message(severity: string, summary: string, messaggio: string) {
    this.messageService.add({ severity: severity, summary: summary, detail: messaggio })
  }
}

@Injectable({
  providedIn: 'root'
})
export class ApiInterceptor implements HttpInterceptor {

  constructor(private storageService: StorageService, private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('/login')) {
      return next.handle(req);
    }

    const userData: AuthUser | null = this.storageService.getUser();
    const token = this.storageService.getToken();

    const modifiedReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token} ${userData?.id}`),
    });

    return next.handle(modifiedReq).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 403 && this.isSessionExpired(token)) {
          this.storageService.clearStorage();
          if (!this.router.url.startsWith('/backoffice/login')) {
            this.router.navigate(['/backoffice/login']);
          }
        }
        return throwError(() => err);
      }),
    );
  }

  /** 403 da permessi (es. operatore) non deve sloggare; solo JWT scaduto/assente. */
  private isSessionExpired(token: string): boolean {
    if (!token || token === 'null' || token === 'undefined') {
      return !!this.storageService.getUser()?.id;
    }
    try {
      const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
      return typeof payload.exp === 'number' && payload.exp * 1000 <= Date.now();
    } catch {
      return true;
    }
  }
}